export const GET_CLEANING_REPORTS_REQUEST = 'GET_CLEANING_REPORTS_REQUEST';
export const GET_CLEANING_REPORTS_SUCCESS = 'GET_CLEANING_REPORTS_SUCCESS';
export const GET_CLEANING_REPORTS_FAIL = 'GET_CLEANING_REPORTS_FAIL';

export const CLOSE_CLEANING_REPORT_ROUTE_IMAGE_MODAL =
  'CLOSE_CLEANING_REPORT_ROUTE_IMAGE_MODAL';

export const GET_CLEANING_REPORT_ROUTE_IMAGE_REQUEST =
  'GET_CLEANING_REPORT_ROUTE_IMAGE_REQUEST';
export const GET_CLEANING_REPORT_ROUTE_IMAGE_SUCCESS =
  'GET_CLEANING_REPORT_ROUTE_IMAGE_SUCCESS';
export const GET_CLEANING_REPORT_ROUTE_IMAGE_FAIL =
  'GET_CLEANING_REPORT_ROUTE_IMAGE_FAIL';

export const RESET_CLEANING_REPORTS_STATE = 'RESET_CLEANING_REPORTS_STATE';
